// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2Ma5n","log":"ModalInventoryLogs_log__21vK2","date":"ModalInventoryLogs_date__3ooYJ","userName":"ModalInventoryLogs_userName__1iTAh"};